/**
 * @generated SignedSource<<27d66eab829e89ba017f17104702246d>>
 * @relayHash 9a31bcd84d31650a9d9bf2ee5045af08
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb

import type { ConcreteRequest } from 'relay-runtime';
export type useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery$variables = {
  spaceKey: string;
};
export type useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery$data = {
  readonly space: {
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery = {
  response: useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery$data;
  variables: useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "key",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "Space",
    "kind": "LinkedField",
    "name": "space",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "concreteType": "Content",
        "kind": "LinkedField",
        "name": "homepage",
        "plural": false,
        "selections": [
          (v1/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "9a31bcd84d31650a9d9bf2ee5045af08",
    "id": "d71357cc47e8209b6702e84965f7bc95e5209b869d1f811a6841b17bccc364cb",
    "metadata": {},
    "name": "useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery",
    "operationKind": "query",
    "text": "query useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery($spaceKey:String!){space(key:$spaceKey){id,homepage{id}}}"
  }
};
})();

(node as any).hash = "57678666b7eece7bec595c782b54d686";

export default node;
